import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReadResult } from '../../models/net/result/crud/read-result';
import { HttpFactory } from '../../utilities/http-factory';

@Injectable({
    providedIn: 'root'
})

export class HtmlContentService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "htmlcontent");
    }

    public anonReadById(id: number): Observable<ReadResult | null> {

        const result = HttpFactory.anonGet<ReadResult>(this.http, this._controllerName + "/envelope/anonreadbyid/" + id, this._apiBaseUrl);

        return result;
    }

    public anonReadByMoniker(moniker: string): Observable<ReadResult | null> {

        const result = HttpFactory.anonGet<ReadResult>(this.http, this._controllerName + "/envelope/anonreadbymoniker/" + moniker, this._apiBaseUrl);

        return result;
    }
}
